import React, { useState } from 'react';
import {
  Box,
  Typography,
  Button,
  TextField,
  Paper,
  InputAdornment,
  IconButton,
  Fade,
  CircularProgress,
  Stepper,
  Step,
  StepLabel,
  Slider,
  Chip
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CalculateIcon from '@mui/icons-material/Calculate';
import HomeWorkOutlinedIcon from '@mui/icons-material/HomeWorkOutlined';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import BedIcon from '@mui/icons-material/Bed';
import BathtubIcon from '@mui/icons-material/Bathtub';
import CountertopsIcon from '@mui/icons-material/Countertops';
import WeekendIcon from '@mui/icons-material/Weekend';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import DoorFrontIcon from '@mui/icons-material/DoorFront';
import WindowIcon from '@mui/icons-material/Window';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

// SVG house type illustrations
const HouseTypeSVG = ({ type }) => {
  if (type === 'kampung') {
    return (
      <svg viewBox="0 0 80 50" style={{ width: '100%', height: '100%' }}>
        {/* Stilts */}
        <rect x="15" y="32" width="3" height="16" fill="#8B6914" rx="0.5"/>
        <rect x="62" y="32" width="3" height="16" fill="#8B6914" rx="0.5"/>
        <rect x="38" y="32" width="3" height="16" fill="#8B6914" rx="0.5"/>
        {/* House body (wood) */}
        <rect x="10" y="20" width="60" height="14" fill="#D2A679" stroke="#A0784C" strokeWidth="0.5" rx="1"/>
        {/* Roof - traditional steep */}
        <polygon points="40,2 5,22 75,22" fill="#8B4513" stroke="#6B3410" strokeWidth="0.5"/>
        <polygon points="40,5 10,22 70,22" fill="#A0522D"/>
        {/* Window */}
        <rect x="22" y="24" width="8" height="6" fill="#87CEEB" stroke="#A0784C" strokeWidth="0.5" rx="0.5"/>
        {/* Door */}
        <rect x="44" y="22" width="7" height="12" fill="#6B3410" stroke="#5C2D0E" strokeWidth="0.5" rx="0.5"/>
        {/* Stairs */}
        <line x1="51" y1="34" x2="58" y2="48" stroke="#8B6914" strokeWidth="1.5"/>
        <line x1="44" y1="34" x2="51" y2="48" stroke="#8B6914" strokeWidth="1.5"/>
        {/* Ground */}
        <line x1="0" y1="48" x2="80" y2="48" stroke="#4a7c59" strokeWidth="1" opacity="0.5"/>
      </svg>
    );
  }
  if (type === 'terrace') {
    return (
      <svg viewBox="0 0 80 50" style={{ width: '100%', height: '100%' }}>
        {/* Left neighbor hint */}
        <rect x="0" y="15" width="8" height="33" fill="#C0C0C0" opacity="0.4"/>
        {/* Right neighbor hint */}
        <rect x="72" y="15" width="8" height="33" fill="#C0C0C0" opacity="0.4"/>
        {/* Main house body */}
        <rect x="8" y="15" width="64" height="33" fill="#E8DDD3" stroke="#B0A090" strokeWidth="0.5"/>
        {/* Roof */}
        <polygon points="8,15 40,3 72,15" fill="#7A3B2E" stroke="#5C2D1E" strokeWidth="0.5"/>
        {/* Upper window */}
        <rect x="30" y="18" width="10" height="8" fill="#87CEEB" stroke="#B0A090" strokeWidth="0.5" rx="0.5"/>
        <line x1="35" y1="18" x2="35" y2="26" stroke="#B0A090" strokeWidth="0.3"/>
        {/* Door */}
        <rect x="33" y="32" width="10" height="16" fill="#6B3410" stroke="#5C2D0E" strokeWidth="0.5" rx="0.5"/>
        <circle cx="41" cy="40" r="0.8" fill="#DAA520"/>
        {/* Windows */}
        <rect x="16" y="32" width="10" height="8" fill="#87CEEB" stroke="#B0A090" strokeWidth="0.5" rx="0.5"/>
        <line x1="21" y1="32" x2="21" y2="40" stroke="#B0A090" strokeWidth="0.3"/>
        <rect x="52" y="32" width="10" height="8" fill="#87CEEB" stroke="#B0A090" strokeWidth="0.5" rx="0.5"/>
        <line x1="57" y1="32" x2="57" y2="40" stroke="#B0A090" strokeWidth="0.3"/>
        {/* Car porch line */}
        <line x1="8" y1="30" x2="72" y2="30" stroke="#B0A090" strokeWidth="0.3" strokeDasharray="2,1"/>
        {/* Ground */}
        <line x1="0" y1="48" x2="80" y2="48" stroke="#4a7c59" strokeWidth="1" opacity="0.5"/>
      </svg>
    );
  }
  // bungalow
  return (
    <svg viewBox="0 0 80 50" style={{ width: '100%', height: '100%' }}>
      {/* Main body */}
      <rect x="5" y="18" width="70" height="30" fill="#E8DDD3" stroke="#B0A090" strokeWidth="0.5" rx="1"/>
      {/* Roof */}
      <polygon points="40,2 0,20 80,20" fill="#5C4033" stroke="#4A3328" strokeWidth="0.5"/>
      <polygon points="40,5 5,20 75,20" fill="#6B4C3B"/>
      {/* Porch extension */}
      <rect x="28" y="28" width="24" height="20" fill="#F0E6DC" stroke="#B0A090" strokeWidth="0.5"/>
      <polygon points="28,28 40,22 52,28" fill="#7A5C4B" stroke="#5C4033" strokeWidth="0.3"/>
      {/* Door */}
      <rect x="36" y="34" width="8" height="14" fill="#6B3410" stroke="#5C2D0E" strokeWidth="0.5" rx="0.5"/>
      <circle cx="42" cy="41" r="0.7" fill="#DAA520"/>
      {/* Windows */}
      <rect x="10" y="26" width="12" height="9" fill="#87CEEB" stroke="#B0A090" strokeWidth="0.5" rx="0.5"/>
      <line x1="16" y1="26" x2="16" y2="35" stroke="#B0A090" strokeWidth="0.3"/>
      <line x1="10" y1="30.5" x2="22" y2="30.5" stroke="#B0A090" strokeWidth="0.3"/>
      <rect x="58" y="26" width="12" height="9" fill="#87CEEB" stroke="#B0A090" strokeWidth="0.5" rx="0.5"/>
      <line x1="64" y1="26" x2="64" y2="35" stroke="#B0A090" strokeWidth="0.3"/>
      <line x1="58" y1="30.5" x2="70" y2="30.5" stroke="#B0A090" strokeWidth="0.3"/>
      {/* Garden hints */}
      <circle cx="8" cy="46" r="3" fill="#4a7c59" opacity="0.3"/>
      <circle cx="72" cy="46" r="3" fill="#4a7c59" opacity="0.3"/>
      {/* Ground */}
      <line x1="0" y1="48" x2="80" y2="48" stroke="#4a7c59" strokeWidth="1" opacity="0.5"/>
    </svg>
  );
};

// Finishing level visual indicator
const FinishingIndicator = ({ level }) => {
  const configs = {
    basic: { colors: ['#9E9E9E', '#BDBDBD', '#E0E0E0'], filled: 1 },
    standard: { colors: ['#1976D2', '#42A5F5', '#E0E0E0'], filled: 2 },
    premium: { colors: ['#F9A825', '#FFD54F', '#FFF176'], filled: 3 },
  };
  const config = configs[level] || configs.basic;
  return (
    <Box sx={{ display: 'flex', gap: 0.3, mt: 0.5 }}>
      {[0, 1, 2].map((i) => (
        <Box
          key={i}
          sx={{
            width: 16,
            height: 4,
            borderRadius: 2,
            bgcolor: i < config.filled ? config.colors[0] : '#E0E0E0',
            transition: 'all 0.3s',
          }}
        />
      ))}
    </Box>
  );
};

// Counter input with +/- buttons
const CounterInput = ({ label, value, onChange, min = 0, max = 20, icon, helperText }) => (
  <Box sx={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    py: 1.5,
    borderBottom: '1px solid',
    borderColor: 'divider',
    '&:last-child': { borderBottom: 'none' }
  }}>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
      {icon && <Box sx={{ color: 'text.secondary', display: 'flex' }}>{icon}</Box>}
      <Box>
        <Typography variant="body2" sx={{ fontWeight: 500 }}>{label}</Typography>
        {helperText && (
          <Typography variant="caption" color="text.secondary">{helperText}</Typography>
        )}
      </Box>
    </Box>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <IconButton
        size="small"
        onClick={() => onChange(Math.max(min, value - 1))}
        disabled={value <= min}
        sx={{
          width: 32, height: 32,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 1.5,
          '&:hover': { bgcolor: 'action.hover' }
        }}
      >
        <Typography variant="body2" sx={{ fontWeight: 600, lineHeight: 1 }}>-</Typography>
      </IconButton>
      <Typography
        variant="body1"
        sx={{
          fontWeight: 700,
          minWidth: 32,
          textAlign: 'center',
          color: value > 0 ? 'text.primary' : 'text.disabled'
        }}
      >
        {value}
      </Typography>
      <IconButton
        size="small"
        onClick={() => onChange(Math.min(max, value + 1))}
        disabled={value >= max}
        sx={{
          width: 32, height: 32,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 1.5,
          '&:hover': { bgcolor: 'action.hover' }
        }}
      >
        <Typography variant="body2" sx={{ fontWeight: 600, lineHeight: 1 }}>+</Typography>
      </IconButton>
    </Box>
  </Box>
);

const CompleteHomeEstimator = ({
  onBack,
  onCalculate,
  isCalculating = false,
  language = 'en'
}) => {
  const content = {
    en: {
      title: 'Complete Home Estimator',
      subtitle: 'Get a detailed cost & material breakdown for your entire home',
      step1: 'House Info',
      step2: 'Details',
      step3: 'Rooms',
      section1: 'House Type & Size',
      section2: 'Structure & Finishing',
      section3: 'Rooms & Openings',
      houseType: 'What type of house?',
      kampung: 'Kampung',
      kampungDesc: 'Traditional style on stilts',
      terrace: 'Terrace',
      terraceDesc: 'Standard linked house',
      bungalow: 'Bungalow',
      bungalowDesc: 'Detached, all sides open',
      builtUpArea: 'Built-Up Area',
      areaHint: 'Total floor area of your home',
      floors: 'Number of Floors',
      finishingLevel: 'Finishing Level',
      basic: 'Basic',
      basicDesc: 'Cement floors, basic paint',
      basicRange: 'RM 80-120/sqft',
      standard: 'Standard',
      standardDesc: 'Ceramic tiles, quality finishes',
      standardRange: 'RM 120-180/sqft',
      premium: 'Premium',
      premiumDesc: 'Marble, high-end fixtures',
      premiumRange: 'RM 180-280/sqft',
      wallHeight: 'Wall Height',
      wallType: 'Wall Type',
      brick45: '4.5" Brick',
      brick9: '9" Brick',
      block: 'Concrete Block',
      foundationType: 'Foundation',
      strip: 'Strip Footing',
      pad: 'Pad Footing',
      raft: 'Raft Foundation',
      roofType: 'Roofing',
      metal: 'Metal Deck',
      concrete: 'Concrete Slab',
      tiles: 'Clay/Concrete Tiles',
      ceilingType: 'Ceiling',
      gypsum: 'Gypsum Board',
      pvc: 'PVC Panel',
      plaster: 'Plastered',
      bedrooms: 'Bedrooms',
      bathrooms: 'Bathrooms',
      kitchen: 'Kitchen',
      livingArea: 'Living Area',
      store: 'Store / Utility',
      mainDoors: 'Main Doors',
      mainDoorSize: '7\' x 3\'',
      roomDoors: 'Room Doors',
      roomDoorSize: '7\' x 2.5\'',
      windows: 'Windows',
      windowSize: '4\' x 3\'',
      calculateButton: 'Calculate Estimate',
      calculating: 'Calculating...',
      recommended: 'Recommended',
      advancedSettings: 'Advanced Settings',
      hideAdvanced: 'Hide Advanced',
      projectName: 'Project Name',
      projectNamePlaceholder: 'e.g., My Dream Home',
      next: 'Next',
      back: 'Back',
      rooms: 'Rooms',
      openings: 'Doors & Windows',
      sqft: 'sqft',
      floor: 'Floor',
      costHint: 'Estimated range for this level'
    },
    my: {
      title: 'Pengira Rumah Lengkap',
      subtitle: 'Dapatkan pecahan kos & bahan terperinci untuk seluruh rumah anda',
      step1: 'Info Rumah',
      step2: 'Butiran',
      step3: 'Bilik',
      section1: 'Jenis & Saiz Rumah',
      section2: 'Struktur & Kemasan',
      section3: 'Bilik & Bukaan',
      houseType: 'Jenis rumah apa?',
      kampung: 'Kampung',
      kampungDesc: 'Gaya tradisional bertiang',
      terrace: 'Teres',
      terraceDesc: 'Rumah teres bersambung',
      bungalow: 'Banglo',
      bungalowDesc: 'Sesebuah, semua sisi terbuka',
      builtUpArea: 'Luas Binaan',
      areaHint: 'Jumlah luas lantai rumah',
      floors: 'Bilangan Tingkat',
      finishingLevel: 'Tahap Kemasan',
      basic: 'Asas',
      basicDesc: 'Lantai simen, cat asas',
      basicRange: 'RM 80-120/kps',
      standard: 'Standard',
      standardDesc: 'Jubin seramik, kemasan berkualiti',
      standardRange: 'RM 120-180/kps',
      premium: 'Premium',
      premiumDesc: 'Marmar, kelengkapan mewah',
      premiumRange: 'RM 180-280/kps',
      wallHeight: 'Tinggi Dinding',
      wallType: 'Jenis Dinding',
      brick45: 'Bata 4.5"',
      brick9: 'Bata 9"',
      block: 'Blok Konkrit',
      foundationType: 'Asas',
      strip: 'Tapak Jalur',
      pad: 'Tapak Pad',
      raft: 'Asas Rakit',
      roofType: 'Bumbung',
      metal: 'Dek Logam',
      concrete: 'Papak Konkrit',
      tiles: 'Jubin Tanah Liat',
      ceilingType: 'Siling',
      gypsum: 'Papan Gipsum',
      pvc: 'Panel PVC',
      plaster: 'Diplaster',
      bedrooms: 'Bilik Tidur',
      bathrooms: 'Bilik Air',
      kitchen: 'Dapur',
      livingArea: 'Ruang Tamu',
      store: 'Stor / Utiliti',
      mainDoors: 'Pintu Utama',
      mainDoorSize: '7\' x 3\'',
      roomDoors: 'Pintu Bilik',
      roomDoorSize: '7\' x 2.5\'',
      windows: 'Tingkap',
      windowSize: '4\' x 3\'',
      calculateButton: 'Kira Anggaran',
      calculating: 'Mengira...',
      recommended: 'Disyorkan',
      advancedSettings: 'Tetapan Lanjutan',
      hideAdvanced: 'Sembunyi Lanjutan',
      projectName: 'Nama Projek',
      projectNamePlaceholder: 'cth., Rumah Impian Saya',
      next: 'Seterusnya',
      back: 'Kembali',
      rooms: 'Bilik',
      openings: 'Pintu & Tingkap',
      sqft: 'kaki persegi',
      floor: 'Tingkat',
      costHint: 'Anggaran julat untuk tahap ini'
    }
  };

  const t = content[language] || content.en;

  const [activeStep, setActiveStep] = useState(0);
  const [formData, setFormData] = useState({
    projectName: '',
    houseType: 'terrace',
    builtUpArea: '1200',
    floors: 1,
    finishingLevel: 'standard',
    wallHeight: '10',
    wallType: 'brick45',
    foundationType: 'strip',
    roofType: 'metal',
    ceilingType: 'gypsum',
    bedrooms: 3,
    bathrooms: 2,
    kitchen: 1,
    livingArea: 1,
    store: 1,
    mainDoors: 2,
    roomDoors: 5,
    windows: 8
  });

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = () => {
    onCalculate(formData);
  };

  const isValid = formData.builtUpArea && parseFloat(formData.builtUpArea) > 0;
  const steps = [t.step1, t.step2, t.step3];

  // Option card component for selections
  const OptionCard = ({ selected, onClick, children, recommended, sx: sxProp }) => (
    <Paper
      elevation={0}
      onClick={onClick}
      sx={{
        p: 1.5,
        border: '2px solid',
        borderColor: selected ? 'primary.main' : 'divider',
        borderRadius: 2,
        cursor: 'pointer',
        position: 'relative',
        bgcolor: selected ? 'primary.50' : 'background.paper',
        transition: 'all 0.2s ease',
        '&:hover': {
          borderColor: selected ? 'primary.main' : 'text.secondary',
          transform: 'translateY(-1px)',
        },
        ...sxProp
      }}
    >
      {selected && (
        <CheckCircleIcon
          sx={{
            position: 'absolute',
            top: 6,
            right: 6,
            fontSize: 18,
            color: 'primary.main'
          }}
        />
      )}
      {recommended && (
        <Chip
          label={t.recommended}
          size="small"
          color="primary"
          sx={{
            position: 'absolute',
            top: -10,
            left: '50%',
            transform: 'translateX(-50%)',
            height: 20,
            fontSize: '0.6rem',
            fontWeight: 700,
          }}
        />
      )}
      {children}
    </Paper>
  );

  // Structure option pill
  const StructurePill = ({ label, value, selected, onClick }) => (
    <Box
      onClick={onClick}
      sx={{
        px: 2,
        py: 1,
        borderRadius: 2,
        border: '1.5px solid',
        borderColor: selected ? 'primary.main' : 'divider',
        bgcolor: selected ? 'primary.main' : 'transparent',
        color: selected ? 'white' : 'text.primary',
        cursor: 'pointer',
        fontWeight: selected ? 600 : 400,
        fontSize: '0.8rem',
        textAlign: 'center',
        transition: 'all 0.2s ease',
        '&:hover': {
          borderColor: 'primary.main',
        },
        flex: 1,
      }}
    >
      {label}
    </Box>
  );

  // Step 1: House Info
  const renderStep1 = () => (
    <Fade in timeout={300}>
      <Box>
        {/* Project Name */}
        <TextField
          fullWidth
          label={t.projectName}
          placeholder={t.projectNamePlaceholder}
          value={formData.projectName}
          onChange={(e) => handleChange('projectName', e.target.value)}
          sx={{ mb: 3 }}
          size="small"
          variant="outlined"
        />

        {/* House Type */}
        <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1.5, color: 'text.secondary' }}>
          {t.houseType}
        </Typography>
        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 1.5, mb: 3 }}>
          {['kampung', 'terrace', 'bungalow'].map((type) => (
            <OptionCard
              key={type}
              selected={formData.houseType === type}
              onClick={() => handleChange('houseType', type)}
              sx={{ textAlign: 'center', pt: 1 }}
            >
              <Box sx={{ width: '100%', height: 36, mb: 0.5 }}>
                <HouseTypeSVG type={type} />
              </Box>
              <Typography variant="body2" sx={{ fontWeight: 600, fontSize: '0.8rem' }}>
                {t[type]}
              </Typography>
              <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.65rem', lineHeight: 1.2, display: 'block' }}>
                {t[type + 'Desc']}
              </Typography>
            </OptionCard>
          ))}
        </Box>

        {/* Built-Up Area */}
        <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 0.5, color: 'text.secondary' }}>
          {t.builtUpArea}
        </Typography>
        <Typography variant="caption" color="text.disabled" sx={{ display: 'block', mb: 1 }}>
          {t.areaHint}
        </Typography>
        <TextField
          fullWidth
          type="number"
          value={formData.builtUpArea}
          onChange={(e) => handleChange('builtUpArea', e.target.value)}
          InputProps={{
            endAdornment: <InputAdornment position="end">{t.sqft}</InputAdornment>,
            sx: { fontSize: '1.2rem', fontWeight: 600 }
          }}
          sx={{ mb: 1 }}
        />
        <Slider
          value={parseInt(formData.builtUpArea) || 800}
          onChange={(e, val) => handleChange('builtUpArea', val.toString())}
          min={400}
          max={5000}
          step={50}
          sx={{ mb: 3, mx: 1 }}
          marks={[
            { value: 400, label: '400' },
            { value: 1500, label: '1,500' },
            { value: 3000, label: '3,000' },
            { value: 5000, label: '5,000' },
          ]}
        />

        {/* Floors */}
        <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1.5, color: 'text.secondary' }}>
          {t.floors}
        </Typography>
        <Box sx={{ display: 'flex', gap: 1.5, mb: 3 }}>
          {[1, 2, 3].map((floor) => (
            <OptionCard
              key={floor}
              selected={formData.floors === floor}
              onClick={() => handleChange('floors', floor)}
              sx={{ flex: 1, textAlign: 'center', py: 1.5 }}
            >
              <Typography variant="h6" sx={{ fontWeight: 700, color: formData.floors === floor ? 'primary.main' : 'text.primary' }}>
                {floor}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {t.floor}
              </Typography>
            </OptionCard>
          ))}
        </Box>

        {/* Finishing Level */}
        <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1.5, color: 'text.secondary' }}>
          {t.finishingLevel}
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, mb: 2 }}>
          {['basic', 'standard', 'premium'].map((level) => (
            <OptionCard
              key={level}
              selected={formData.finishingLevel === level}
              onClick={() => handleChange('finishingLevel', level)}
              recommended={level === 'standard'}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                mt: level === 'standard' ? 0.5 : 0,
              }}
            >
              <Box sx={{ flex: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>{t[level]}</Typography>
                  <FinishingIndicator level={level} />
                </Box>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.25 }}>
                  {t[level + 'Desc']}
                </Typography>
              </Box>
              <Chip
                label={t[level + 'Range']}
                size="small"
                variant="outlined"
                sx={{
                  fontSize: '0.65rem',
                  height: 22,
                  borderColor: formData.finishingLevel === level ? 'primary.main' : 'divider',
                  color: formData.finishingLevel === level ? 'primary.main' : 'text.secondary',
                }}
              />
            </OptionCard>
          ))}
        </Box>
      </Box>
    </Fade>
  );

  // Step 2: Structure Details
  const renderStep2 = () => (
    <Fade in timeout={300}>
      <Box>
        {/* Wall Height */}
        <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, color: 'text.secondary' }}>
          {t.wallHeight}
        </Typography>
        <TextField
          fullWidth
          type="number"
          value={formData.wallHeight}
          onChange={(e) => handleChange('wallHeight', e.target.value)}
          InputProps={{
            endAdornment: <InputAdornment position="end">ft</InputAdornment>
          }}
          sx={{ mb: 3 }}
          size="small"
        />

        {/* Wall Type */}
        <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, color: 'text.secondary' }}>
          {t.wallType}
        </Typography>
        <Box sx={{ display: 'flex', gap: 1, mb: 3 }}>
          {[
            { value: 'brick45', label: t.brick45 },
            { value: 'brick9', label: t.brick9 },
            { value: 'block', label: t.block },
          ].map((opt) => (
            <StructurePill
              key={opt.value}
              label={opt.label}
              value={opt.value}
              selected={formData.wallType === opt.value}
              onClick={() => handleChange('wallType', opt.value)}
            />
          ))}
        </Box>

        {/* Foundation Type */}
        <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, color: 'text.secondary' }}>
          {t.foundationType}
        </Typography>
        <Box sx={{ display: 'flex', gap: 1, mb: 3 }}>
          {[
            { value: 'strip', label: t.strip },
            { value: 'pad', label: t.pad },
            { value: 'raft', label: t.raft },
          ].map((opt) => (
            <StructurePill
              key={opt.value}
              label={opt.label}
              value={opt.value}
              selected={formData.foundationType === opt.value}
              onClick={() => handleChange('foundationType', opt.value)}
            />
          ))}
        </Box>

        {/* Roof Type */}
        <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, color: 'text.secondary' }}>
          {t.roofType}
        </Typography>
        <Box sx={{ display: 'flex', gap: 1, mb: 3 }}>
          {[
            { value: 'metal', label: t.metal },
            { value: 'concrete', label: t.concrete },
            { value: 'tiles', label: t.tiles },
          ].map((opt) => (
            <StructurePill
              key={opt.value}
              label={opt.label}
              value={opt.value}
              selected={formData.roofType === opt.value}
              onClick={() => handleChange('roofType', opt.value)}
            />
          ))}
        </Box>

        {/* Ceiling Type */}
        <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, color: 'text.secondary' }}>
          {t.ceilingType}
        </Typography>
        <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
          {[
            { value: 'gypsum', label: t.gypsum },
            { value: 'pvc', label: t.pvc },
            { value: 'plaster', label: t.plaster },
          ].map((opt) => (
            <StructurePill
              key={opt.value}
              label={opt.label}
              value={opt.value}
              selected={formData.ceilingType === opt.value}
              onClick={() => handleChange('ceilingType', opt.value)}
            />
          ))}
        </Box>
      </Box>
    </Fade>
  );

  // Step 3: Rooms & Openings
  const renderStep3 = () => (
    <Fade in timeout={300}>
      <Box>
        {/* Rooms */}
        <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, px: 2, mb: 2 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 600, pt: 2, pb: 1, color: 'text.secondary', display: 'flex', alignItems: 'center', gap: 1 }}>
            <MeetingRoomIcon fontSize="small" color="primary" />
            {t.rooms}
          </Typography>
          <CounterInput
            label={t.bedrooms}
            value={formData.bedrooms}
            onChange={(val) => handleChange('bedrooms', val)}
            max={10}
            icon={<BedIcon fontSize="small" />}
          />
          <CounterInput
            label={t.bathrooms}
            value={formData.bathrooms}
            onChange={(val) => handleChange('bathrooms', val)}
            max={10}
            icon={<BathtubIcon fontSize="small" />}
          />
          <CounterInput
            label={t.kitchen}
            value={formData.kitchen}
            onChange={(val) => handleChange('kitchen', val)}
            max={5}
            icon={<CountertopsIcon fontSize="small" />}
          />
          <CounterInput
            label={t.livingArea}
            value={formData.livingArea}
            onChange={(val) => handleChange('livingArea', val)}
            max={5}
            icon={<WeekendIcon fontSize="small" />}
          />
          <CounterInput
            label={t.store}
            value={formData.store}
            onChange={(val) => handleChange('store', val)}
            max={5}
            icon={<WarehouseIcon fontSize="small" />}
          />
        </Paper>

        {/* Openings */}
        <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, px: 2, mb: 2 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 600, pt: 2, pb: 1, color: 'text.secondary', display: 'flex', alignItems: 'center', gap: 1 }}>
            <DoorFrontIcon fontSize="small" color="primary" />
            {t.openings}
          </Typography>
          <CounterInput
            label={t.mainDoors}
            value={formData.mainDoors}
            onChange={(val) => handleChange('mainDoors', val)}
            max={10}
            icon={<DoorFrontIcon fontSize="small" />}
            helperText={t.mainDoorSize}
          />
          <CounterInput
            label={t.roomDoors}
            value={formData.roomDoors}
            onChange={(val) => handleChange('roomDoors', val)}
            max={20}
            icon={<DoorFrontIcon fontSize="small" />}
            helperText={t.roomDoorSize}
          />
          <CounterInput
            label={t.windows}
            value={formData.windows}
            onChange={(val) => handleChange('windows', val)}
            max={30}
            icon={<WindowIcon fontSize="small" />}
            helperText={t.windowSize}
          />
        </Paper>
      </Box>
    </Fade>
  );

  const stepContent = [renderStep1, renderStep2, renderStep3];

  return (
    <Fade in timeout={400}>
      <Box sx={{ p: { xs: 2, sm: 3 }, maxWidth: 520, mx: 'auto' }}>
        {/* Header */}
        <Box sx={{ mb: 3 }}>
          <Button
            startIcon={<ArrowBackIcon />}
            onClick={onBack}
            sx={{ mb: 2, textTransform: 'none', color: 'text.secondary' }}
          >
            {language === 'my' ? 'Kembali' : 'Back'}
          </Button>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
            <Box
              sx={{
                width: 48,
                height: 48,
                borderRadius: 2.5,
                background: (theme) =>
                  `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 4px 12px rgba(79, 70, 229, 0.25)',
              }}
            >
              <HomeWorkOutlinedIcon sx={{ fontSize: 24, color: '#fff' }} />
            </Box>
            <Box>
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                {t.title}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {t.subtitle}
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* Stepper */}
        <Stepper activeStep={activeStep} alternativeLabel sx={{ mb: 3 }}>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>
                <Typography variant="caption" sx={{ fontWeight: 500 }}>{label}</Typography>
              </StepLabel>
            </Step>
          ))}
        </Stepper>

        {/* Step Content */}
        <Box sx={{ minHeight: 400 }}>
          {stepContent[activeStep]()}
        </Box>

        {/* Navigation */}
        <Box sx={{ display: 'flex', gap: 1.5, mt: 3 }}>
          {activeStep > 0 && (
            <Button
              variant="outlined"
              onClick={() => setActiveStep(activeStep - 1)}
              sx={{ flex: 1, py: 1.5, textTransform: 'none', borderRadius: 2 }}
            >
              {t.back}
            </Button>
          )}
          {activeStep < 2 ? (
            <Button
              variant="contained"
              endIcon={<ArrowForwardIcon />}
              onClick={() => setActiveStep(activeStep + 1)}
              sx={{
                flex: activeStep === 0 ? 1 : 2,
                py: 1.5,
                textTransform: 'none',
                borderRadius: 2,
                fontWeight: 600,
              }}
            >
              {t.next}
            </Button>
          ) : (
            <Button
              variant="contained"
              size="large"
              onClick={handleSubmit}
              disabled={!isValid || isCalculating}
              startIcon={isCalculating ? <CircularProgress size={20} color="inherit" /> : <CalculateIcon />}
              sx={{
                flex: 2,
                py: 1.5,
                fontSize: '1rem',
                fontWeight: 700,
                borderRadius: 2,
                background: (theme) =>
                  `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
                boxShadow: '0 8px 24px rgba(79, 70, 229, 0.3)',
                '&:hover': {
                  transform: 'translateY(-1px)',
                  boxShadow: '0 12px 32px rgba(79, 70, 229, 0.4)',
                },
                '&:disabled': {
                  background: 'action.disabledBackground'
                },
                transition: 'all 0.2s ease-in-out',
              }}
            >
              {isCalculating ? t.calculating : t.calculateButton}
            </Button>
          )}
        </Box>
      </Box>
    </Fade>
  );
};

export default CompleteHomeEstimator;
